import React, { Component } from 'react';
import axios from "axios";
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from '@material-ui/core/LinearProgress';
import Toast from './toast';

class RHPImportComponent extends React.Component<any, any> {

    // API Endpoints
    custom_file_upload_url = `https://gatewayapi.invest19.com/api/ipo/document/upload`;
    canvas: any;

    // state
    constructor(props) {
        super(props);
        this.canvas = React.createRef()
        this.state = {
            image_file: null,
            image_preview: '',
            uploadURL: '',
            url: '',
            uploadPercentage: 0,
            isUploaded: false,
            toastOpen: false,
            toastMessage: '',
            toastSeverity: 'success'
        }
    }

    // File Selection Handler
    handleImagePreview = (e) => {
        if (e.target.files && e.target.files[0]) {
            let image_as_base64 = URL.createObjectURL(e.target.files[0])
            let image_as_files = e.target.files[0];

            this.setState({
                image_preview: image_as_base64,
                image_file: image_as_files,
                uploadPercentage: 0,
                isUploaded: false
            })
        }
    }

    // File Submit Handler
    handleSubmitFile = () => {
        if (this.state.image_file !== null) {

            let formData = new FormData();
            formData.append('ipoName', 'ipo');
            formData.append('document', this.state.image_file);

            var ref = this;
            this.setState({ uploadPercentage: 1 });

            axios.post(
                this.custom_file_upload_url,
                formData,
                {
                    headers: {
                        "Content-type": "multipart/form-data",
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        this.setState({ uploadPercentage: percentCompleted });
                    }
                }
            )
                .then(res => {
                    console.log(`Success`, res.data);

                    setTimeout(() => {
                        this.setState({ uploadPercentage: 0 })
                    }, 3000);

                    this.setState({
                        isUploaded: true,
                        toastOpen: true,
                        toastMessage: 'Successfully Uploaded',
                        toastSeverity: 'success'
                    });

                    if (res.data && res.data.response && res.data.response.url) {
                        ref.props.upload(res.data.response.url);
                    } else if (res.data && res.data.url) {
                        ref.props.upload(res.data.url);
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.setState({
                        uploadPercentage: 0,
                        toastOpen: true,
                        toastMessage: 'Upload failed: ' + err.message,
                        toastSeverity: 'error'
                    });
                })
        }
    }

    // Cancel Selection Handler
    handleCancel = () => {
        this.setState({
            image_file: null,
            image_preview: '',
            uploadPercentage: 0,
            isUploaded: false
        });
        if (this.canvas && this.canvas.current) {
            this.canvas.current.value = "";
        }
    }

    handleToastClose = () => {
        this.setState({ toastOpen: false });
    }

    // render from here
    render() {
        const { uploadPercentage, image_file } = this.state;
        return (
            <div className="custom-image-upload" style={{ width: '100%', marginTop: '10px' }}>
                <Toast
                    open={this.state.toastOpen}
                    message={this.state.toastMessage}
                    severity={this.state.toastSeverity}
                    handleClose={this.handleToastClose}
                />

                {/* Hidden File Input */}
                <input
                    type="file"
                    accept="application/pdf"
                    onChange={this.handleImagePreview}
                    ref={this.canvas}
                    style={{ display: 'none' }}
                />

                <div style={{ display: 'flex', alignItems: 'center', minHeight: '40px', border: '1px solid #ccc', borderRadius: '4px', padding: '5px 10px' }}>

                    {/* STATE 1: No File Selected */}
                    {!image_file && (
                        <div
                            style={{ width: '100%', cursor: 'pointer', textAlign: 'center', color: '#666', padding: '5px 0' }}
                            onClick={() => { if (this.canvas.current) this.canvas.current.click() }}
                        >
                            Select your file
                        </div>
                    )}

                    {/* STATE 2: File Selected */}
                    {image_file && (
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                                <span style={{ fontSize: '13px', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '150px' }}>
                                    {image_file.name}
                                </span>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {!this.state.isUploaded && (
                                    <CheckRoundedIcon onClick={this.handleSubmitFile} style={{ cursor: 'pointer', color: '#4caf50' }} />
                                )}

                                {uploadPercentage === 0 && (
                                    <CloseRoundedIcon onClick={this.handleCancel} style={{ marginLeft: this.state.isUploaded ? '0' : '10px', cursor: 'pointer', color: '#f44336' }} />
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {/* Upload Progress Bar */}
                <div style={{ width: '100%', marginTop: '5px', height: '4px' }}>
                    {uploadPercentage > 0 && <LinearProgress variant="determinate" value={uploadPercentage} />}
                </div>
            </div>
        );
    }
}

export default RHPImportComponent;
